var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPowershell = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 32 32"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "powershell_svg__a",
  x1: 23.325,
  x2: 7.26,
  y1: -118.543,
  y2: -104.193,
  gradientTransform: "matrix(1 0 0 -1 0 -96)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#5391fe"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3e6dbf"
})), /*#__PURE__*/React.createElement("linearGradient", {
  xlinkHref: "#powershell_svg__a",
  id: "powershell_svg__b",
  x1: 7.1,
  x2: 23.001,
  y1: -104.002,
  y2: -118.292
}))), /*#__PURE__*/React.createElement("path", {
  d: "M3.174 26.589a1.15 1.15 0 0 1-.928-.423 1.23 1.23 0 0 1-.21-1.052L6.233 6.78a1.8 1.8 0 0 1 1.681-1.37h20.912a1.16 1.16 0 0 1 .928.423 1.24 1.24 0 0 1 .21 1.052l-4.2 18.335a1.8 1.8 0 0 1-1.681 1.37H3.174Z",
  style: {
    fillRule: "evenodd",
    fill: "url(#powershell_svg__a)"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.914 5.646h20.912a.913.913 0 0 1 .908 1.187l-4.2 18.334a1.575 1.575 0 0 1-1.451 1.187H3.174a.913.913 0 0 1-.908-1.187l4.2-18.334a1.57 1.57 0 0 1 1.448-1.187",
  style: {
    fillRule: "evenodd",
    fill: "url(#powershell_svg__b)"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.04 21.544h5.086a1.118 1.118 0 0 1 0 2.234H16.04a1.118 1.118 0 0 1 0-2.234M19.339 16.578a1.76 1.76 0 0 1-.591.6l-9.439 6.775a1.224 1.224 0 0 1-1.438-1.977l8.512-6.164v-.126L11.035 10a1.224 1.224 0 0 1 1.782-1.672l6.418 6.827a1.166 1.166 0 0 1 .104 1.423",
  style: {
    fill: "#2c5591",
    fillRule: "evenodd"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.1 16.342a1.75 1.75 0 0 1-.59.6l-9.436 6.776a1.225 1.225 0 0 1-1.439-1.977l8.513-6.164v-.127L10.8 9.761a1.224 1.224 0 0 1 1.783-1.672L19 14.916a1.16 1.16 0 0 1 .1 1.426M15.9 21.412h5.086a1.059 1.059 0 1 1 0 2.118H15.9a1.059 1.059 0 1 1 0-2.118",
  style: {
    fill: "#fff",
    fillRule: "evenodd"
  }
}));
export default SvgPowershell;